/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { Extractor } from "./extractor";
export { I18NHtmlParser } from "./i18n_html_parser";
export { MessageBundle } from "./message_bundle";
export { Serializer } from "./serializers/serializer";
export { Xliff } from "./serializers/xliff";
export { Xliff2 } from "./serializers/xliff2";
export { Xmb } from "./serializers/xmb";
export { Xtb } from "./serializers/xtb";
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../../../packages/compiler/esm5/src/i18n/index.js